import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "w-full absolute mt-2 shadow-lg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-normal truncate" }, "Valikud puuduvad...")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MSimpleDropdownOption = _resolveComponent("MSimpleDropdownOption")!
  const _component_MDropDownMenuTransition = _resolveComponent("MDropDownMenuTransition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "trigger")
    ]),
    _createVNode(_component_MDropDownMenuTransition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-gray-100 overflow-x-hidden absolute z-50 w-full", _ctx.fixedHeight ? 'max-h-44' : ''])
          }, [
            _renderSlot(_ctx.$slots, "options", {}, () => [
              _createVNode(_component_MSimpleDropdownOption, { active: false }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ])
          ], 2)
        ], 512), [
          [_vShow, _ctx.open]
        ])
      ]),
      _: 3
    })
  ]))
}